import React from 'react';
import { useLanguage } from '../context/LanguageContext';

// Επίσημη σελίδα UNESCO για την Παλαιά Πόλη της Κέρκυρας
export const UNESCO_URL = 'https://whc.unesco.org/en/list/978/';

/**
 * Σύνδεσμος προς την επίσημη σελίδα UNESCO.
 * Το κείμενο έρχεται από μεταφραστικό κλειδί, ώστε να διαφέρει ανά σημείο
 * (π.χ. σύντομο στο hero, πλήρες στη σελίδα της βίλας).
 * Υπογράμμιση + gold: δεν βασίζεται ΜΟΝΟ στο χρώμα για να ξεχωρίσει.
 */
const UnescoLink = ({ textKey, className = '' }) => {
  const { t } = useLanguage();
  return (
    <a
      href={UNESCO_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`text-[#D4A72C] underline underline-offset-2 decoration-[#D4A72C]/50 hover:decoration-[#D4A72C] transition-colors ${className}`}
    >
      {t(textKey)}
    </a>
  );
};

export default UnescoLink;
